/**
 * @desc 通过银行账号获取银行信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BankInfoResponse>>;
export function request(
  body: Array<defs.basics.BankAccountNumRequest>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getBankInfoListByAccountNum`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
